import { styled } from '@mui/material/styles';
import { WsColors, Item } from 'wisestep-base';

export default styled(Item)(() => ({
  background: WsColors.TertiaryShades50,
  position: 'fixed',
  bottom: '1px',
  width: '100%',
  zIndex: 1400,
}));
